<template>
  <div class="page-status">
    <img :src="notFind">
  </div>
</template>

<script>
export default {
  data () {
    return {
      notFind:'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/empty/404.png'
    }
  }
}
</script>
<style scoped lang="less">
.page-status {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  img {
    width: 532px;
  }
}
</style>
